export default "__VITE_ASSET__D5J8ATOU__"